export const isValidHTML = content => {
  if (!content || typeof content !== 'string') return false;

  const trimmedContent = content.trim();
  if (!trimmedContent.startsWith('<') || !trimmedContent.endsWith('>')) return false;

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(trimmedContent, 'text/html');
    return !doc.querySelector('parsererror');
  } catch (error) {
    return false;
  }
};
